// Path: ./src/app/pages/CameraPage/styled.ts
import { Button, ButtonProps } from "@mui/material";
import styled from "styled-components";
import { styled as MuiStyled } from "@mui/material/styles";

export const Video = styled.video`
  display: block;
  width: 90%;
  border-radius: 10px;
  min-height: 400px;
  padding-bottom: 70px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
    rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
`;

export const CameraWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  position: relative;
`;

export const ColorButton = MuiStyled(Button)<ButtonProps>(() => ({
  color: "#FA8723",
  backgroundColor: "transparent",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

export const StartButton = MuiStyled(Button)<ButtonProps>(() => ({
  color: "#FA8723",
  width: 200,
  height: 200,
  borderRadius: 200,
  fontSize: 22,
  backgroundColor: "transparent",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textTransform: "capitalize",
  padding: 15,
  boxShadow:
    " rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));
